module.exports = __webpack_public_path__ + "static/media/favouriteHollow.c236033d.svg";